import { Action, OperationType } from '../../../dispatcher/Types';

/**
 * Closes dashboard drawer
 */
export const CloseDashboardDrawer: Action = [{
  moduleName: 'Dashboard',
  name: 'closeDrawer'
}];

export const ClearAllFilters: Action = [{
  data: {
    data: {}
  },
  evaluate: true,
  moduleId: '{dashboardGridModuleId}',
  args: ['data'],
  moduleName: 'DashboardGrid',
  name: 'setFilterData'
}, {
  data: {
    sort: []
  },
  evaluate: true,
  moduleId: '{dashboardGridModuleId}',
  args: ['sort'],
  moduleName: 'DashboardGrid',
  name: 'setSort'
}, {
  evaluate: true,
  moduleId: '{searchBarModuleId}',
  moduleName: 'SearchBar',
  name: 'resetSearchOnlyInput'
}, {
  evaluate: true,
  moduleId: '{tabPanelModuleId}',
  moduleName: 'TabPanel',
  name: 'getActiveTabUniqueValue',
  mappingName: 'activeTabUniqueValue',
  type: OperationType.addOperationData
}, {
  independent: true,
  data: {
    template: {
      tabPanelItem: {
        bind: {
          uniqueItemValue: '{activeTabUniqueValue}'
        }
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{moduleId}',
  independent: true,
  name: 'onTabRemoved',
  moduleName: 'Dashboard',
  args: ['tabPanelItem']
}, {
  independent: true,
  data: {
    template: {
      reloadGridConfig: {
        assignedParams: false,
        bind: {
          navigationGridModuleId: '{dashboardGridModuleId}'
        }
      }
    }
  },
  name: 'reloadGrid',
  type: OperationType.action
}];

export const getFilterData: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '{filterUrl}'
      }
    }
  },
  mappingName: 'filterData',
  type: OperationType.request
}, {
  evaluate: true,
  moduleId: '{navigationGridModuleId}',
  moduleName: '{navigationGridModuleName}',
  name: 'setFilterData',
  args: ['filterData']
}];

export const setFilterData: Action = [{
  condition: '{filterData}',
  conditionOperations: [{
    evaluate: true,
    moduleName: '{topLevelComponentName}',
    name: 'setUsersFilterData',
    args: ['filterData', 'refreshedFilterId']
  }],
  type: OperationType.conditional
}];

export const changeDashboardRoute: Action = [{
  name: 'setFilterData',
  type: OperationType.action
}, {
  type: OperationType.redirect
}, {
  evaluate: true,
  moduleName: '{dashboardModuleName}',
  name: 'emptyFn',
  waitForModule: true
}, {
  data: {
    filterData: {}
  },
  type: OperationType.data
}, {
  name: 'setFilterData',
  type: OperationType.action
}];

export const columnFilterChanged: Action = [{
  data: {
    saveScroll: false
  },
  type: OperationType.data
}, {
  args: ['params', 'url', 'method', 'saveScroll'],
  name: 'reloadGridData',
  moduleName: 'DashboardGrid'
}];

export const refreshGridData: Action = [{
  name: 'refreshGridData',
  moduleName: 'DashboardGrid'
}];

export const columnSortChanged: Action = [{
  name: 'refreshAnyNavigationGridData',
  type: OperationType.action
}];

export const columnLocaleSortChanged: Action = [{
  data: {
    template: {
      bind: {
        sortParams: '{scrollRequestParams}.sort'
      }
    }
  },
  evaluate: true,
  moduleId: '{navigationGridModuleId}',
  moduleName: '{navigationGridModuleName}',
  name: 'localSort',
  args: ['sortParams']
}];

export const openSidebarDrawerWithData: Action = [{
  name: 'getRowDataItem',
  type: OperationType.action
}, {
  moduleName: 'Dashboard',
  name: 'setSelectedRowData',
  args: ['dataItem']
}, {
  data: {
    template: {
      bind: {
        title: '{dataItem.name}'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'Dashboard',
  name: 'openSidebarDrawer'
}, {
  moduleName: 'DashboardDrawer',
  name: 'setTitle',
  args: ['title']
}];

export const openSidebarDrawer: Action = [{
  moduleName: 'Dashboard',
  name: 'openSidebarDrawer'
}];

export const closeSidebarDrawer: Action = [{
  data: {
    template: {
      dataItem: null
    }
  },
  type: OperationType.data
}, {
  moduleName: 'Dashboard',
  name: 'setSelectedRowData',
  args: ['dataItem']
}, {
  moduleName: 'Dashboard',
  name: 'closeSidebarDrawer'
}];

export const updateFilterParamsBySelectedTab: Action = [{
  evaluate: true,
  moduleId: '{searchBarModuleId}',
  moduleName: 'SearchBar',
  name: 'setSearchValue',
  args: ['searchValue']
}, {
  condition: '{sort}',
  conditionOperations: [{
    evaluate: true,
    moduleId: '{dashboardGridModuleId}',
    args: ['sort'],
    name: 'setSort',
    moduleName: 'DashboardGrid'
  }],
  type: OperationType.conditional
}, {
  condition: '{filterData}',
  conditionOperations: [{
    evaluate: true,
    moduleId: '{dashboardGridModuleId}',
    args: ['filterData'],
    moduleName: 'DashboardGrid',
    name: 'setFilterData'
  }],
  type: OperationType.conditional
}, {
  condition: '{keepTabsMounted}',
  conditionOperations: [{
    data: {
      template: {
        reloadGridConfig: {
          bind: {
            params: '{params}',
            navigationGridModuleId: '{dashboardGridModuleId}'
          }
        },
        mask: 'self'
      }
    },
    name: 'reloadGrid',
    type: OperationType.action
  }],
  elseOperations: [{
    condition: '{params}',
    conditionOperations: [{
      evaluate: true,
      moduleId: '{dashboardGridModuleId}',
      executeType: 'visible',
      args: ['params', 'url', 'method', 'saveScroll'],
      name: 'reloadGridData',
      moduleName: 'DashboardGrid'
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const setDashboardTitleTotalItems: Action = [{
  moduleName: 'DashboardTitle',
  independent: true,
  name: 'setTotalItems',
  args: ['totalElements', 'totalSubElements']
}];

export const openDashboardDrawer: Action = [{
  moduleName: 'Dashboard',
  name: 'openDrawer'
}];

export const expandAllTreeGrid: Action = [{
  moduleName: 'NavigationTreeGrid',
  name: 'toggleExpanded',
  displayed: true,
  executeType: 'visible'
}];
